export const styles = {
    buttonStyle: { background: 'transparent', border: 'none', cursor: 'pointer' },
    rowStyle: { borderRadius: '40px' },
};
